<template>
  <div class="overlay" :class="{abierto: modal_abierto}">
    <div class="modal">
      <div class="close" @click="cerrar">X</div>
      <div class="header">
        <h2>{{titulo}}</h2>
      </div>
      <div class="body scroll-light">
        <div class="logo-app">
          <img src="@/assets/img/logo.png" alt>
        </div>
        <span>{{version}}</span>
        <p><a target="_BLANK" :href="enlace1" @click="openLink(enlace1, $event)">{{ enlace1.replace("http://", "") }}</a></p>
        <p><a target="_BLANK" :href="enlace2" @click="openLink(enlace2, $event)">{{ enlace2.replace("http://", "") }}</a></p>
        <h3>{{contactanos}}:</h3>
        <ul>
          <li><b>Correo: </b>{{correo}}</li>
          <li><b>Línea infomativa: </b>{{tel_info}}</li>
          <li><b>Mesa de Ayuda Técnica: </b>{{tel_mat}}</li>
        </ul>
      </div>
      <div class="footer">
        <div class="redes-sociales">
          <a :href="facebook" target="_blank" @click="openLink(facebook, $event)" class="logo">
            <img src="@/assets/img/facebook.png" alt>
          </a>
          <a :href="twitter" target="_blank" @click="openLink(twitter, $event)" class="logo">
            <img src="@/assets/img/twitter.png" alt>
          </a>
          <a :href="instagram" target="_blank" @click="openLink(instagram, $event)" class="logo">
            <img src="@/assets/img/instagram.png" alt>
          </a>
          <a :href="youtube" target="_blank" @click="openLink(youtube, $event)" class="logo">
            <img src="@/assets/img/youtube.png" alt>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isElectron from 'is-electron'
export default {
  name: "ModalInfo",
  components: {},
  data: function() {
    return {
      modal_abierto: false
    };
  },
  computed: {
    titulo(){ return this.$store.getters.about.titulo; },
    version(){ return this.$store.getters.about.version; },
    enlace1(){ return this.$store.getters.about.enlace1; },
    enlace2(){ return this.$store.getters.about.enlace2; },
    contactanos(){ return this.$store.getters.about.contactanos; },
    correo(){ return this.$store.getters.about.correo; },
    tel_info(){ return this.$store.getters.about.tel_info; },
    tel_mat(){ return this.$store.getters.about.tel_mat; },
    facebook(){ return this.$store.getters.about.facebook; },
    twitter(){ return this.$store.getters.about.twitter; },
    instagram(){ return this.$store.getters.about.instagram; },
    youtube(){ return this.$store.getters.about.youtube; },
  },
  methods: {
    abrir_info() {
      this.modal_abierto = true;
    },
    cerrar() {
      this.modal_abierto = false;
    },
    openLink(url, evt){
      if (isElectron()) {
        evt.preventDefault();
        const open = require('open');
				open(url);
        return false;
			}
      return true;
    }
  },
  created() {},
  mounted() {
    this.$globalEvent.$on("abrirInfo", this.abrir_info);
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/responsiveness.scss";
a{
  cursor: url("~@/assets/img/cursors/pointer.png"), pointer;
  color: white;
}

ul {
  list-style-type: none;
  // text-align: left;
}

.overlay {
  z-index: 9;
  position: fixed;
  width: 100%;
  height: 100%;
  right: 0px;
  top: 0px;
  background-color: rgba(0, 0, 0, 0);
  visibility: hidden;
  transition: visibility 0ms linear 500ms, background-color 500ms;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.overlay.abierto {
  visibility: visible;
  background-color: rgba(0, 0, 0, 0.6);
  transition-delay: 0s;
}

.modal {
  color: white;
  width: 900px;
  height: 800px;
  max-width: calc(100% - 20px);
  max-height: calc(100% - 20px);
  // background-color: rgb(255, 125, 125);
  background: linear-gradient(to bottom, #002d87 0%, #a800c2 100%);
  border-radius: 25px;
  // box-shadow: 0px 0px 0px 0px black;
  transform: translateY(-200px);
  opacity: 0;
  transition: transform 500ms, opacity 500ms;
  display: flex;
  flex-direction: column;
}

.close {
  cursor: url("~@/assets/img/cursors/pointer.png"), pointer;
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: white;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 50px;
  font-weight: 700;
  font-size: 18pt;
  color: red;
}

.overlay.abierto > .modal {
  transform: translateY(0px);
  opacity: 1;
}
.body{
  padding-top: 10px;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch; 
  flex-grow: 1;
  font-size: 15pt;
  mask-image: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 5%,rgba(0,0,0,1) 95%,rgba(0,0,0,0) 100%);
}
.logo-app > img{
  width: 150px;
  filter: drop-shadow(0px 3px 5px #222);
}
.redes-sociales {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.logo {
  width: 50px;
  margin: 15px;
  // height: 50px;
}
.logo > img {
  cursor: url("~@/assets/img/cursors/pointer.png"), pointer;
  filter: drop-shadow(0px 3px 5px #222);
  max-width: 50px;
  max-height: 50px;
}
</style>
